import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://15wjwxx0uf.execute-api.eu-west-3.amazonaws.com/dev/'
});

export default instance;

